import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TermsOfService from "@app.automotus.io/components/TermsOfService";

export const TermsOfServiceWrapper: React.FC<TermsOfServiceWrapperProps> = ({
  variant,
  onBack,
  onChange,
  hideTitle,
}) => {
  return (
    <Box sx={{ position: "relative", pl: { xs: 0, lg: 2 }, pt: { xs: 2, tiny: 3, lg: 3 } }}>
      <TermsOfService
        hideTitle={hideTitle}
        TitleTypographyProps={{ sx: { fontWeight: 500, fontSize: { xs: "16px", lg: "34px" } } }}
      />
      <Box sx={{ position: "sticky", bottom: 0, backgroundColor: "white" }} pt={2}>
        {variant === "display" ? (
          <Box sx={{ display: "flex", justifyContent: "center", pt: 2, pb: 4 }}>
            <Button
              variant="contained"
              onClick={onBack}
              sx={{ textTransform: "none", width: { xs: "100%", md: "auto" }, minWidth: { md: 160 } }}
            >
              Back
            </Button>
          </Box>
        ) : (
          <Grid container direction="row" alignItems="space-between" xs={12} ml={0} pb={{ xs: 2, lg: 0 }}>
            <Grid item xs={6} pr={1}>
              <Button
                variant="outlined"
                onClick={() => onChange && onChange("decline")}
                fullWidth
                sx={{
                  textTransform: "unset",
                  py: { xs: 0.5, tiny: 0.75, lg: 1 },
                  fontSize: { xs: "14px", tiny: "16px", lg: "18px" },
                  height: { xs: "30px", tiny: "36px", lg: "42px" },
                  fontWeight: 500,
                }}
              >
                Decline
              </Button>
            </Grid>
            <Grid item xs={6} pl={1}>
              <Button
                variant="contained"
                onClick={() => onChange && onChange("accept")}
                sx={{
                  textTransform: "unset",
                  py: { xs: 0.5, tiny: 0.75, lg: 1 },
                  fontSize: { xs: "14px", tiny: "16px", lg: "18px" },
                  height: { xs: "30px", tiny: "36px", lg: "42px" },
                  fontWeight: 500,
                }}
                fullWidth
              >
                Accept
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default TermsOfServiceWrapper;

export interface TermsOfServiceWrapperProps {
  /** Event handler that gets triggered when the user clicks Back button */
  onBack?: () => void;
  /** Event handler that gets triggered when the user elects to change the state*/
  onChange?: (op: "accept" | "decline") => void;
  /** This indicates whether the component is in display mode or select mode. Display mode is only used in landing page, and select mode is used in CurbPass Setup page */
  variant: "display" | "select";
  /** Hides the terms title, e.g. when the surrounding container already shows one */
  hideTitle?: boolean;
}
